// extracted by mini-css-extract-plugin
export var createdDate = "_ld-1";
export var divider = "_ld-2";
export var headerDivider = "_ld-3";
export var messagesCard = "_ld-0";
export var messagesContainer = "_ld-7";
export var messagesContainerWrapper = "_ld-4";
export var pointerCapturingButtonBoxes = "_ld-a";
export var showLeftPanelButton = "_ld-9";
export var showMoreButton = "_ld-c";
export var showMoreButtonContainer = "_ld-b";
export var summaryTitle = "_ld-6";
export var systemMessageCardWrapper = "_ld-d";
export var topButtons = "_ld-8";
export var withPadding = "_ld-5";